export default {
  state: {
    UIControl: {
      // currentSessionAccount: null,
      uploadFile: {},
      loadingMsg: false,
      isShowBottom: true,
      isPutChat: true,
      // numbers: null,
    },
  },
  mutations: {
    // SET_CURRENT_SESSION_ACCOUNT(state, ccv) {
    //   state.UIControl.currentSessionAccount = ccv
    // },
    SET_SCROLL(state,data) {
      state.UIControl.isShowBottom = data;
    },
    SET_PUT_CHAT(state,data) {
      state.UIControl.isPutChat = data;
    },
    SET_UPLOAD_FILE(state, data) {
      state.UIControl.uploadFile = data
    },
    SET_UPLOAD_PROCESS(state, data) {
      state.UIControl.uploadFile[data.name].process = data.process
    },
    SET_UPLOAD_FILE_SUCCESS(state, data) {
      state.UIControl.uploadFile[data.name].file = data.file
    },
    // SET_PUT_SESSION(state, data) {
    //   state.UIControl.numbers = data
    // }
  },
  actions: {
    srollBottom({commit, state}, currentBollen) {
      if (state.UIControl.isShowBottom === currentBollen) return
      commit('SET_SCROLL', currentBollen)
    },
    setPutChat({commit}, currentBollen) {
      commit('SET_PUT_CHAT',currentBollen)
    },
    // isShowSession({commit}, number) {
    //   commit('SET_PUT_SESSION',number)
    // }
    
  }
}
